"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleorAPI = void 0;
const config_1 = require("../config");
const data_1 = require("../data");
const ApolloClientManager_1 = require("../data/ApolloClientManager");
const LocalStorageHandler_1 = require("../helpers/LocalStorageHandler");
const jobs_1 = require("../jobs");
const state_1 = require("../state");
const Cart_1 = require("./Cart");
const Checkout_1 = require("./Checkout");
__exportStar(require("./Checkout"), exports);
__exportStar(require("./Cart"), exports);
class SaleorAPI {
    constructor(client, apiProxy, config, onStateUpdate) {
        this.legacyAPIProxy = apiProxy;
        const finalConfig = Object.assign(Object.assign(Object.assign({}, config_1.defaultConfig), config), { loadOnStart: Object.assign(Object.assign({}, config_1.defaultConfig.loadOnStart), config === null || config === void 0 ? void 0 : config.loadOnStart) });
        const { loadOnStart } = finalConfig;
        const localStorageHandler = new LocalStorageHandler_1.LocalStorageHandler();
        const apolloClientManager = new ApolloClientManager_1.ApolloClientManager(client);
        const saleorState = new state_1.SaleorState(localStorageHandler, apolloClientManager);
        const localStorageManager = new data_1.LocalStorageManager(localStorageHandler, saleorState);
        const jobsManager = new jobs_1.JobsManager(localStorageHandler, apolloClientManager);
        if (onStateUpdate) {
            saleorState.subscribeToNotifiedChanges(onStateUpdate);
        }
        this.checkout = new Checkout_1.SaleorCheckoutAPI(saleorState, loadOnStart.checkout, jobsManager);
        this.cart = new Cart_1.SaleorCartAPI(localStorageManager, apolloClientManager, saleorState, loadOnStart.cart, jobsManager);
        this.legacyAPIProxy.attachAuthListener(authenticated => {
            if (!authenticated) {
                localStorageHandler.setCheckout({});
                localStorageHandler.setPayment({});
                localStorageHandler.setJobs(null);
            }
        });
    }
}
exports.SaleorAPI = SaleorAPI;
//# sourceMappingURL=index.js.map